import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  testData: [],
  testDataError: { error: false, message: '' },
  testDataLoading: false,
};

const testDataSlice = createSlice({
  name: 'testData',
  initialState,
  reducers: {
    setTestData(state, action) {
      state.testData = action.payload;
      state.testDataError = { error: false, message: '' };
    },
    setTestDataLoading(state, action) {
      state.testDataLoading = action.payload; // ✅ correct field name
    },
    setTestDataError(state, action) {
      state.testDataError = action.payload;
      state.testData = [];
    },
  },
});

export const {
  setTestData,
  setTestDataLoading,
  setTestDataError,
} = testDataSlice.actions;

export default testDataSlice.reducer;          // <- import this in configureStore